import React, { useState } from "react";
import { Outlet, Link } from "react-router-dom";
import { useAuthContext } from "../lib/authLib";
import { FaBars } from "react-icons/fa";
import { IoMoon, IoSunny } from "react-icons/io5";
import LogoutButton from "./logoutButton";

const Navbar = () => {
  const { user } = useAuthContext();
  const [menuOpen, setMenuOpen] = useState(false);

  // Initialize dark mode from localStorage, defaulting to true if not set
  const [dark, setDark] = React.useState(() => {
    const savedDark = localStorage.getItem("darkMode");
    // If no preference is saved, default to true
    return savedDark === null ? true : savedDark === "true";
  });

  // Apply dark mode on initial render
  React.useEffect(() => {
    if (dark) {
      document.body.classList.add("dark");
    }
  }, []);

  const darkModeHandler = () => {
    const newDarkValue = !dark;
    setDark(newDarkValue);
    localStorage.setItem("darkMode", String(newDarkValue));
    document.body.classList.toggle("dark");
  };

  return (
    <div className="min-h-screen flex flex-col">
      <nav className="bg-white dark:bg-gray-800 p-4 flex justify-between items-center sticky top-0 z-50 text-gray-800 dark:text-white shadow-md">
        <div className="flex items-center">
          <Link to="/home">
            <img
              src={dark ? "/logo-dark.png" : "/logo-light.png"}
              alt="Logo"
              className="h-12 mr-4"
            />
          </Link>
          <ul className="flex space-x-4">
            {user?.isSuperAdmin ? (
              <>
                <li>
                  <Link
                    to="/home"
                    className="hover:text-gray-600 dark:text-white dark:hover:text-gray-400"
                  >
                    Home
                  </Link>
                </li>
                <li>
                  <Link
                    to="/users"
                    className="hover:text-gray-600 dark:text-white dark:hover:text-gray-400"
                  >
                    Users
                  </Link>
                </li>
                <li>
                  <Link
                    to="/rules"
                    className="hover:text-gray-600 dark:text-white dark:hover:text-gray-400"
                  >
                    Rules
                  </Link>
                </li>
                <li>
                  <Link
                    to="/charities"
                    className="hover:text-gray-600 dark:text-white dark:hover:text-gray-400"
                  >
                    Charities
                  </Link>
                </li>
                <li>
                  <Link
                    to="/admin"
                    className="hover:text-gray-600 dark:text-white dark:hover:text-gray-400"
                  >
                    Admin
                  </Link>
                </li>
              </>
            ) : (
              <>
                <li>
                  <Link
                    to="/home"
                    className="hover:text-gray-600 dark:text-white dark:hover:text-gray-400"
                  >
                    Home
                  </Link>
                </li>
                <li>
                  <Link
                    to="/rules"
                    className="hover:text-gray-600 dark:text-white dark:hover:text-gray-400"
                  >
                    Rules
                  </Link>
                </li>
                <li>
                  <Link
                    to="/messages"
                    className="hover:text-gray-600 dark:text-white dark:hover:text-gray-400"
                  >
                    Messages
                  </Link>
                </li>
                <li>
                  <Link
                    to="/settings"
                    className="hover:text-gray-600 dark:text-white dark:hover:text-gray-400"
                  >
                    Settings
                  </Link>
                </li>
                <li>
                  <Link
                    to="/charities"
                    className="hover:text-gray-600 dark:text-white dark:hover:text-gray-400"
                  >
                    Charities
                  </Link>
                </li>
              </>
            )}
          </ul>
        </div>
        <div className="relative text-gray-800 dark:text-white">
          {user ? (
            <div className="flex items-center">
              <button
                onClick={darkModeHandler}
                className="p-2 mr-2 hover:bg-gray-700 rounded-full"
              >
                {!dark && <IoSunny size={24} className="text-xl" />}
                {dark && <IoMoon size={24} className="text-xl" />}
              </button>
              <div className="relative">
                <button
                  onClick={() => setMenuOpen(!menuOpen)}
                  className="flex items-center space-x-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg px-3 py-2"
                >
                  <span className="text-sm">
                    {user.firstName} {user.lastName}
                  </span>
                  <FaBars size={24} className="text-lg" />
                </button>
                {menuOpen && (
                  <div
                    className="absolute right-0 mt-2 bg-white dark:bg-gray-800 rounded-lg shadow-lg py-1 z-50"
                    style={{
                      minWidth: "200px",
                      maxWidth: "400px",
                      width: "max-content",
                    }}
                  >
                    <div
                      className="px-4 py-2 text-sm text-gray-500 dark:text-gray-400 border-b border-gray-200 dark:border-gray-700 truncate"
                      style={{
                        maxWidth: "calc(100vw - 32px)",
                        width: "100%",
                        display: "flex",
                      }}
                    >
                      <span className="truncate" title={user.email}>
                        {user.email}
                      </span>
                    </div>
                    <LogoutButton className="w-full text-left px-4 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700" />
                  </div>
                )}
              </div>
            </div>
          ) : (
            <div className="text-gray-800 dark:text-white">Loading...</div>
          )}
        </div>
      </nav>
      <main className="bg-gray-100 dark:bg-gray-900 text-black dark:text-white flex-grow p-4">
        <Outlet />
      </main>
    </div>
  );
};

export default Navbar;
